/* eslint-disable react/require-default-props */
import React, { FC } from "react";
import { createUseStyles } from "react-jss";
import InstagramObject from "Components/InstagramObject";
import styles from "./styles";

export interface MediaObjectProps {
  img: any;
  children: any;
  alt?: string;
  style?: {};
  onClick?: (e: any) => void;
  media?: any;
}

export const MediaObject: FC<MediaObjectProps> = (props: MediaObjectProps) => {
  const useStyles = createUseStyles(styles);

  const classes = useStyles({ ...props });
  const { img, alt, children, onClick, style, media } = props;

  return (
    <button
      className={classes.container}
      onClick={onClick}
      tabIndex={0}
      type="button"
      data-testid="mediaObject"
    >
      {media && media[0]?.network === "instagram" ? (
        <InstagramObject
          embedId={media[0].videoid ?? media[0].url}
          onClick={onClick}
          alt={alt || "Media Content"}
          className={classes.media}
          top={-55}
          left={media[0].videoid ? -65 : 0}
          width="100%"
          height="100%"
          iframeWidth={media[0].videoid ? "250%" : "150%"}
          iframeHeight="170%"
          style={{ borderRadius: "8px" }}
        />
      ) : (
        <img
          src={img}
          alt={alt || "Media Content"}
          className={classes.media}
          style={style}
          data-testid="image"
        />
      )}
      <div className={classes.mediaIcon}>{children}</div>
    </button>
  );
};
